/// <reference path="./index.d.ts" />
import * as React from 'react';
import { getBenefits } from './service';
import { Dialog, Button } from '@alifd/next';
import { getText } from '../../utils/i18n';
import safeLog from '@alife/bc-safe-log';
import './index.scss';

export default class Benefits extends React.Component<
  { i18n: any; productId: number; language: string },
  { visible: boolean; info: any }
> {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      info: null,
    };
  }

  componentDidMount() {
    const { productId, language } = this.props;
    getBenefits(productId, language).then(
      (res: PcBenefits.BenefitsRes) => {
        if (res.data && Object.keys(res.data).length) {
          safeLog('/sc.details.commonLogs', 'info=&action=BenfitsWindowExpose');
          this.setState({
            info: res.data,
          });
        }
      },
      err => {
        // console.log(err);
      },
    );
  }

  onOpen = () => {
    this.setState({
      visible: true,
    });
    safeLog('/sc.details.commonLogs', 'info=&action=BenfitsWindow');
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { i18n } = this.props;
    const { info } = this.state;

    const i18nMap = {
      title: getText(
        i18n,
        'benefits.dialog.title',
        'Exclusive rights for PRO Buyers',
      ),
      more: getText(i18n, 'benefits.more', 'View More'),
      benefits: getText(i18n, 'benefits.title', 'Benefits'),
    };

    if (!info) return null;

    return (
      <div className="buyer-benefits detail-mainscreen-center-grid">
        <dl className="buyer-benefits">
          <dt className="market-action-list__dt">{i18nMap.benefits}</dt>
          <dd className="market-action-list__dd benefits-dd">
            {/* 选出第一个 */}
            <img className="golden-buyer-logo" src={info && info.levelLogo} />
            <span className="golden-buyer-first-benefit">
              {info && info.benefitList && info.benefitList[0].name}
            </span>
            <Button
              onClick={this.onOpen}
              ghost
              text
              className="buyer-benefits-more"
            >{`${i18nMap.more} >`}</Button>
          </dd>
          <Dialog
            visible={this.state.visible}
            onOk={this.onClose}
            closeable
            onCancel={this.onClose}
            onClose={this.onClose}
            footer={false}
            title={i18nMap.title}
            className="buyer-benefits-dialog"
            style={{ width: 400 }}
          >
            <ul className="buyer-benefits-dialog-ul">
              {info.benefitList.map(benefit => {
                return (
                  <li className="buyer-benefits-dialog-li">
                    <div className="buyer-benefits-dialog-title2">
                      <img
                        className="golden-buyer-logo"
                        src={info && info.levelLogo}
                      />
                      <span>{benefit.name}</span>
                    </div>
                    <div>{benefit.benefitDescription}</div>
                  </li>
                );
              })}
            </ul>
          </Dialog>
        </dl>
      </div>
    );
  }
}
